export { MegaMenu } from './mega-menu';
export { hoseasonsDestinations, hoseasonsInspiration, } from './data/hoseasons/en';
export { cottagesDestinations, cottagesInspiration } from './data/cottages/en';
export { novasolDestinations, novasolInspiration } from './data/novasol/da';
//# sourceMappingURL=index.js.map